import { render } from "./SVGPlus.vue?vue&type=template&id=6a53354f"
import script from "./SVGPlus.vue?vue&type=script&lang=js"
export * from "./SVGPlus.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__